import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { GiftRegistryFlowService } from '../../../../shared/services/gift-registry-flow/gift-registry-flow.service';
import { PaymentsRouteSegments } from '../../../../shared/constants/route-paths/PaymentsRouteSegments';
import { GiftRegistryRoute } from '../../../../shared/constants/route-paths/GiftRegistrySegments';

export const giftRegistryFlowGuard: CanActivateFn = () => {
  const giftRegistryFlowService = inject(GiftRegistryFlowService);
  const router = inject(Router);

  const flowData = giftRegistryFlowService.getFlowState();

  if (!flowData) {
    void router.navigate(['/', PaymentsRouteSegments.payments, GiftRegistryRoute.Base]);
    return false;
  }

  return true;
};
